import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProtocolIndependentPipe } from '@fi-shared/fi-pipes/protocol-independent.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [ProtocolIndependentPipe],
    providers: [ProtocolIndependentPipe],
    exports: [ProtocolIndependentPipe],
})
export class PipesModule {}
